import { type FirebaseApp, type FirebaseOptions, initializeApp } from 'firebase/app';
import { type Auth, getAuth } from 'firebase/auth';
import { type Firestore, getFirestore } from 'firebase/firestore';

export interface FirebaseHandles {
  app: FirebaseApp;
  auth: Auth;
  db: Firestore;
}

/**
 * Firebase Hosting liefert die Konfiguration unter diesem Pfad aus. Sie gehoert deshalb
 * NICHT ins Bundle -- sonst muesste bei jedem Projektwechsel neu gebaut werden.
 */
const KONFIG_PFAD = '/__/firebase/init.json';

let bereit: Promise<FirebaseHandles> | null = null;

async function baueHandles(): Promise<FirebaseHandles> {
  const antwort = await fetch(KONFIG_PFAD);
  if (!antwort.ok) {
    throw new Error(`${KONFIG_PFAD} nicht erreichbar (HTTP ${antwort.status})`);
  }
  const optionen = (await antwort.json()) as FirebaseOptions;
  const app = initializeApp(optionen);
  return { app, auth: getAuth(app), db: getFirestore(app) };
}

export function initFirebase(): Promise<FirebaseHandles> {
  // Gecacht wird der Promise, nicht sein Ergebnis: zwei gleichzeitige Aufrufe beim Start
  // sollen sich EINEN fetch teilen. Bei einem Fehler wird der Cache geleert, damit ein
  // zweiter Versuch nicht dauerhaft denselben Fehler bekommt.
  if (!bereit) {
    bereit = baueHandles().catch((fehler: unknown) => {
      bereit = null;
      throw fehler;
    });
  }
  return bereit;
}

export function resetFirebaseForTests(): void {
  bereit = null;
}
